<template>
	<v-color-picker
		:hide-mode-switch="hideModeSwitch"
		:mode="mode"
		:show-swatches="showSwatches"
		:swatches="swatches"
		:value="value"
		:width="width"
		v-bind="$attrs"
		v-on="unhandled_events"
		@update:color="update_color"
	/>
</template>

<script>
export default {
	model: {
		prop: 'value',
		event: 'input'
	},
	props: {
		hideModeSwitch: {
			type: Boolean,
			default: false
		},
		mode: {
			type: String,
			default: 'hexa',
			validator: value => ['rgba', 'hsla', 'hexa'].includes(value)
		},
		showSwatches: {
			type: Boolean,
			default: false
		},
		swatches: {
			type: Array,
			default: () => []
		},
		value: {
			type: String,
			default: ''
		},
		width: {
			type: [String, Number],
			default: undefined
		}
	},
	methods: {
		update_color(color) {
			this.$emit('update:color', color)
		}
	},
	computed: {
		unhandled_events() {
			const { 'update:color': updateColor, ...rest } = this.$listeners;
			return rest;
		}
	}
};
</script>
